import React, { useEffect } from 'react';
import { NavSidebarButton, Spinner, useThemeContext } from '@insurancemenu/imenu-components-lib';
import { Mail } from '@insurancemenu/imenu-components-lib/dist/icons';
import { observer } from 'mobx-react-lite';
import { InviteEmployersDelegate } from 'store/modules/group/ui-stores/inviteEmployersDelegate';
import { SpinnerWrapperStyled } from './styles';
import InviteEmployersModal from '../InviteEmployersModal';
import {
  INVITE_EMPLOYER_BTN_TEST_ID,
  INVITE_EMPLOYER_COUNT_TEST_ID,
  INVITE_EMPLOYER_SPINNER_TEST_ID,
} from '../constants';

interface InviteEmployerSectionProps {
  inviteEmployersDelegate: InviteEmployersDelegate;
}

const InviteEmployerSection: React.FC<InviteEmployerSectionProps> = observer(({ inviteEmployersDelegate }) => {
  const {
    getEmployersForGroup,
    groupModule: {
      group: { id: groupId },
    },
    isInitialDataLoading,
    employerDelegates,
    open,
  } = inviteEmployersDelegate;

  useEffect(() => {
    if (groupId) {
      void getEmployersForGroup();
    }
  }, [groupId]);

  const { accentColor } = useThemeContext();
  return (
    <>
      <NavSidebarButton
        disabled={isInitialDataLoading}
        leftIconProp={Mail}
        rightNode={
          !isInitialDataLoading ? (
            <span style={{ color: accentColor }} data-test-id={INVITE_EMPLOYER_COUNT_TEST_ID}>
              ({employerDelegates.length})
            </span>
          ) : (
            <SpinnerWrapperStyled data-test-id={INVITE_EMPLOYER_SPINNER_TEST_ID}>
              <Spinner size="1.6rem" />
            </SpinnerWrapperStyled>
          )
        }
        onClick={open}
        data-test-id={INVITE_EMPLOYER_BTN_TEST_ID}
      >
        Invite Employer
      </NavSidebarButton>
      <InviteEmployersModal inviteEmployersDelegate={inviteEmployersDelegate} />
    </>
  );
});

export default InviteEmployerSection;
